import React from "react";
import BookingCard from "../BookingCard/BookingCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import moment from "moment";

function MyDonationDetails() {
	const location = useLocation();
	let details = {
		Paymentdate: "Payment Date :",
		Paymenttime: "Payment Time",
		PaymentStatus: "Payment Status",
		Campaign: "Campaign",
		Total: "Total",
	};

	let payDetails = {
		Paymentdate: "17:30 Am",
		Paymenttime: "29 Dec 22",
		PaymentStatus: "Paid",
		Campaign: "Save Nature",
		Total: "$50.00",
	};

	let mainhead = null;
	let mainnumber = null;
	let smallhead = null;
	return (
		<>
			<Header />
			<section className="plantingMixing-page">
				<div className="container">
					<div className="row">
						<div className="col-lg-3"></div>
						<div className="col-lg-6">
							<div className="detail_amount_total">
								<div className="main_heading">
									<h2 className="main_title">Donation Details</h2>
									<h4 className="main_number">{location?.state?.campaign?.title}</h4>
								</div>
								<div className="card_details">
									<div className="details_head">Summary</div>
									<div className="all_booking_details mt-4">
										<ul>
											<li>
												<span>Donation date</span>
												<span>{location?.state?.created_at.slice(0,10)}</span>
											</li>
											<li>
												<span>Donation time</span>
												<span>{moment(location?.state?.created_at).format("h:mm a")}{" "}</span>
												{/* <span>{location?.state?.created_at.slice(11,16)}</span> */}
											</li>
											<li>
												<span>amount</span>
												<span>${location?.state?.amount}</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-3"></div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
}

export default MyDonationDetails;
